<template>
  <InputWrapper
    v-slot="{ inputId }"
    :input-id="id"
    :label="t('common.paramStatuses', { param: t('manifests.manifests', 1) })"
    class="shipment-manifest-status-filter w-2"
    optional
  >
    <RygenMultiSelect
      :id="inputId"
      v-model="internalValue.manifestStatuses"
      :options="statusOptions"
      option-label="label"
      option-value="value"
      display="chip"
      :placeholder="
        t('common.paramStatuses', { param: t('manifests.manifests', 1) })
      "
    >
      <template #chip="{ value }">
        <ManifestStatusChip :status="value" />
      </template>
      <template #option="{ option }">
        <ManifestStatusChip :status="option.value" />
      </template>
    </RygenMultiSelect>
  </InputWrapper>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { useModelValue } from '@rygen/rygen-ui/composables';
import { mapEnumToTranslatedDropdownValues } from '@rygen/rygen-ui/i18n';

import { ManifestStatus, ShipmentSearchCriteria } from '@/model';

import ManifestStatusChip from '@/components/manifest/ManifestStatusChip.vue';
import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';
import RygenMultiSelect from '@rygen/rygen-ui/components/form/RygenMultiSelect.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  modelValue: {
    type: ShipmentSearchCriteria,
    default: () => new ShipmentSearchCriteria(),
  },
});
const { id, modelValue } = toRefs(props);
const emit = defineEmits<{
  (event: 'update:model-value', newVal: ShipmentSearchCriteria): void;
}>();
const { t } = useI18n();
const { internalValue } = useModelValue(modelValue, {
  emit,
  factoryMethod: (opts: Partial<ShipmentSearchCriteria>) =>
    new ShipmentSearchCriteria(opts),
});

const statusOptions = mapEnumToTranslatedDropdownValues(
  ManifestStatus,
  'ManifestStatus',
);
</script>
